import { Technology } from './types'

export const technologies: Technology[] = [
  // Languages & frameworks (sorted alphabetically)
  {
    id: '1',
    name: 'AngularJS',
    ring: 'hold',
    quadrant: 'languages',
    isNew: false,
    description:
      'Alternative frontend framework, legacy, no longer recommended',
    link: 'https://angularjs.org/',
  },
  {
    id: '2',
    name: 'ASP.NET Core',
    ring: 'trial',
    quadrant: 'languages',
    isNew: true,
    description: 'Modern C# web framework',
    link: 'https://docs.microsoft.com/en-us/aspnet/core/',
  },
  {
    id: '3',
    name: 'C#',
    ring: 'assess',
    quadrant: 'languages',
    isNew: true,
    description: 'High-performance systems and API service development',
    link: 'https://docs.microsoft.com/en-us/dotnet/csharp/',
  },
  {
    id: '4',
    name: 'Dart',
    ring: 'assess',
    quadrant: 'languages',
    isNew: true,
    description: 'Flutter mobile development',
    link: 'https://dart.dev/',
  },
  {
    id: '5',
    name: 'Express.js',
    ring: 'hold',
    quadrant: 'languages',
    isNew: false,
    description: 'Legacy Node.js framework',
    link: 'https://expressjs.com/',
  },
  {
    id: '6',
    name: 'FastAPI',
    ring: 'adopt',
    quadrant: 'languages',
    isNew: false,
    description: 'Modern Python API framework',
    link: 'https://fastapi.tiangolo.com/',
  },
  {
    id: '7',
    name: 'Flutter',
    ring: 'trial',
    quadrant: 'languages',
    isNew: false,
    description:
      'UI toolkit for building natively compiled applications for mobile, web, and desktop from a single codebase',
    link: 'https://flutter.dev/',
  },
  {
    id: '8',
    name: 'GraphQL',
    ring: 'trial',
    quadrant: 'languages',
    isNew: false,
    description: 'API query language',
    link: 'https://graphql.org/',
  },
  {
    id: '9',
    name: 'Kotlin',
    ring: 'assess',
    quadrant: 'languages',
    isNew: false,
    description: 'Android development alternative',
    link: 'https://kotlinlang.org/',
  },
  {
    id: '10',
    name: 'Next.js',
    ring: 'adopt',
    quadrant: 'languages',
    isNew: false,
    description: 'React framework with SSR and routing',
    link: 'https://nextjs.org/',
  },
  {
    id: '11',
    name: 'Python',
    ring: 'assess',
    quadrant: 'languages',
    isNew: false,
    description: 'Data science, ML, and backend services',
    link: 'https://www.python.org/',
  },
  {
    id: '12',
    name: 'React',
    ring: 'adopt',
    quadrant: 'languages',
    isNew: false,
    description: 'Standard library for building UIs',
    link: 'https://react.dev/',
  },
  {
    id: '13',
    name: 'Spring Framework',
    ring: 'adopt',
    quadrant: 'languages',
    isNew: false,
    description: 'Comprehensive framework for building Java applications',
    link: 'https://spring.io/projects/spring-framework',
  },
  {
    id: '14',
    name: 'Swift',
    ring: 'trial',
    quadrant: 'languages',
    isNew: true,
    description: 'Native iOS mobile development',
    link: 'https://swift.org/',
  },
  {
    id: '15',
    name: 'TypeScript',
    ring: 'adopt',
    quadrant: 'languages',
    isNew: false,
    description: 'Primary language for frontend and backend development',
    link: 'https://www.typescriptlang.org/',
  },
  {
    id: '16',
    name: 'VueJS',
    ring: 'trial',
    quadrant: 'languages',
    isNew: false,
    description: 'Alternative frontend framework',
    link: 'https://vuejs.org/',
  },

  // Platforms (sorted alphabetically)
  {
    id: '17',
    name: 'Amazon Web Services (AWS)',
    ring: 'adopt',
    quadrant: 'platforms',
    isNew: false,
    description: 'Comprehensive cloud computing platform',
    link: 'https://aws.amazon.com/',
  },
  {
    id: '18',
    name: 'Azure',
    ring: 'trial',
    quadrant: 'platforms',
    isNew: false,
    description: 'Microsoft cloud computing platform',
    link: 'https://azure.microsoft.com/',
  },
  {
    id: '19',
    name: 'CloudFlare',
    ring: 'adopt',
    quadrant: 'platforms',
    isNew: false,
    description: 'Web performance and security company',
    link: 'https://www.cloudflare.com/',
  },
  {
    id: '20',
    name: 'CloudFront',
    ring: 'adopt',
    quadrant: 'platforms',
    isNew: false,
    description: 'Content Delivery Network (CDN) for fast content delivery',
    link: 'https://aws.amazon.com/cloudfront/',
  },
  {
    id: '21',
    name: 'DigitalOcean',
    ring: 'hold',
    quadrant: 'platforms',
    isNew: false,
    description: 'Cloud infrastructure provider for developers',
    link: 'https://www.digitalocean.com/',
  },
  {
    id: '22',
    name: 'Firebase',
    ring: 'trial',
    quadrant: 'platforms',
    isNew: false,
    description: 'Google BaaS platform',
    link: 'https://firebase.google.com/',
  },
  {
    id: '23',
    name: 'Google Cloud Platform (GCP)',
    ring: 'adopt',
    quadrant: 'platforms',
    isNew: false,
    description: 'Primary cloud infrastructure',
    link: 'https://cloud.google.com/',
  },
  {
    id: '24',
    name: 'Heroku',
    ring: 'hold',
    quadrant: 'platforms',
    isNew: false,
    description: 'Legacy PaaS provider',
    link: 'https://www.heroku.com/',
  },
  {
    id: '25',
    name: 'Kubernetes',
    ring: 'assess',
    quadrant: 'platforms',
    isNew: false,
    description: 'Container orchestration',
    link: 'https://kubernetes.io/',
  },
  {
    id: '26',
    name: 'Netlify',
    ring: 'trial',
    quadrant: 'platforms',
    isNew: false,
    description: 'Frontend hosting and serverless backend services',
    link: 'https://www.netlify.com/',
  },
  {
    id: '27',
    name: 'Supabase',
    ring: 'hold',
    quadrant: 'platforms',
    isNew: false,
    description: 'Open source Firebase alternative',
    link: 'https://supabase.com/',
  },
  {
    id: '28',
    name: 'Vercel',
    ring: 'trial',
    quadrant: 'platforms',
    isNew: false,
    description: 'Frontend hosting and deployment',
    link: 'https://vercel.com/',
  },

  // Techniques (sorted alphabetically)
  {
    id: '29',
    name: 'Agentic AI architecture',
    ring: 'trial',
    quadrant: 'techniques',
    isNew: true,
    description:
      'Designing systems that leverage autonomous AI agents to perform complex tasks, make decisions, and interact with users or other systems in a human-like manner.',
  },
  {
    id: '30',
    name: 'Architecture Decision Record (ADR)',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Documenting architectural decisions and their context to facilitate better understanding and communication within the team.',
    link: 'https://adr.github.io/',
  },
  {
    id: '31',
    name: 'C4 Model',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: true,
    description:
      'A visual language for describing and communicating software architecture. The C4 model breaks down a system into four hierarchical levels of detail: Context, Container, Component, and Code, helping teams to understand and document their architecture effectively.',
    link: 'https://c4model.com/',
  },
  {
    id: '32',
    name: 'Client Side Rendering (CSR) or Single Page Application (SPA)',
    ring: 'assess',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Rendering web pages on the client side using JavaScript frameworks like React or Vue.js.',
  },
  {
    id: '33',
    name: 'Design Systems',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Creating and maintaining a consistent set of design standards, components, and guidelines to ensure a unified user experience across products.',
  },
  {
    id: '34',
    name: 'Diátaxis Documentation Framework',
    ring: 'assess',
    quadrant: 'techniques',
    isNew: true,
    description:
      'A systematic approach to technical documentation that categorizes content into four distinct types: tutorials, how-to guides, reference, and explanation. This framework helps in creating clear, structured, and user-focused documentation.',
    link: 'https://diataxis.fr/',
  },
  {
    id: '35',
    name: 'Feature Toggles',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Using Feature flag management platforms (e.g., LaunchDarkly, Unleash) to enable controlled feature rollouts and A/B testing',
    link: 'https://martinfowler.com/articles/feature-toggles.html',
  },
  {
    id: '36',
    name: 'Incremental Static Regeneration (ISR)',
    ring: 'trial',
    quadrant: 'techniques',
    isNew: true,
    description:
      'Incremental Static Regeneration (ISR) is a technique that allows static content to be updated incrementally without rebuilding the entire site, enabling a hybrid approach between static and dynamic content.',
    link: 'https://nextjs.org/docs/pages/building-your-application/data-fetching/incremental-static-regeneration',
  },
  {
    id: '37',
    name: 'Micro-Frontends',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: true,
    description:
      'Architecting web applications as a composition of independently deployable micro-applications',
    link: 'https://martinfowler.com/articles/micro-frontends.html',
  },
  {
    id: '38',
    name: 'Microservices Architecture',
    ring: 'trial',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Designing applications as a collection of loosely coupled services that can be developed, deployed, and scaled independently.',
    link: 'https://martinfowler.com/articles/microservices.html',
  },
  {
    id: '39',
    name: 'Multi-Tenant Architecture',
    ring: 'assess',
    quadrant: 'techniques',
    isNew: true,
    description:
      'Designing software architectures that allow a single instance of the application to serve multiple customers (tenants) while ensuring data isolation and security.',
  },
  {
    id: '40',
    name: 'OpenAPI for API Contracts',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Using OpenAPI specifications to define and document RESTful APIs, enabling better collaboration and integration between frontend and backend teams',
    link: 'https://swagger.io/specification/',
  },
  {
    id: '41',
    name: 'Progressive Web Apps (PWA)',
    ring: 'hold',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Building web applications that provide a native app-like experience using modern web capabilities.',
  },
  {
    id: '42',
    name: 'Retrieval-Augmented Generation (RAG)',
    ring: 'trial',
    quadrant: 'techniques',
    isNew: true,
    description:
      'Combining retrieval of relevant documents with generative models to improve the accuracy and relevance of AI-generated content.',
  },
  {
    id: '43',
    name: 'Server Side Rendering (SSR)',
    ring: 'adopt',
    quadrant: 'techniques',
    isNew: false,
    description:
      'A technique for building server-side rendered (SSR) applications using Next.js or other frameworks.',
  },
  {
    id: '44',
    name: 'Static Site Generation (SSG)',
    ring: 'assess',
    quadrant: 'techniques',
    isNew: false,
    description:
      'Pre-rendering web pages at build time for improved performance and SEO using frameworks like Next.js or Gatsby.',
  },

  // Tools (sorted alphabetically)
  {
    id: '45',
    name: 'Ansible',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Configuration management and automation',
    link: 'https://www.ansible.com/',
  },
  {
    id: '46',
    name: 'ArgoCD',
    ring: 'assess',
    quadrant: 'tools',
    isNew: true,
    description: 'GitOps continuous delivery',
    link: 'https://argo-cd.readthedocs.io/',
  },
  {
    id: '47',
    name: 'BrowserStack',
    ring: 'trial',
    quadrant: 'tools',
    isNew: false,
    description: 'Cross-browser testing platform',
    link: 'https://www.browserstack.com/',
  },
  {
    id: '48',
    name: 'BugSnag',
    ring: 'hold',
    quadrant: 'tools',
    isNew: true,
    description: 'Error monitoring and reporting tool',
    link: 'https://www.bugsnag.com/',
  },
  {
    id: '49',
    name: 'ChatGPT',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: true,
    description: 'AI-powered code generation and assistance',
    link: 'https://chat.openai.com/',
  },
  {
    id: '50',
    name: 'Claude Code',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'AI-powered code generation and assistance by Anthropic.',
    link: 'https://claude.ai/',
  },
  {
    id: '51',
    name: 'Cypress',
    ring: 'assess',
    quadrant: 'tools',
    isNew: false,
    description: 'Alternative E2E testing framework',
    link: 'https://www.cypress.io/',
  },
  {
    id: '52',
    name: 'Datadog',
    ring: 'trial',
    quadrant: 'tools',
    isNew: false,
    description:
      'Monitoring and analytics platform for cloud-scale applications',
    link: 'https://www.datadoghq.com/',
  },
  {
    id: '53',
    name: 'Docker',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Containerization platform',
    link: 'https://www.docker.com/',
  },
  {
    id: '54',
    name: 'Elasticsearch',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Distributed, RESTful search and analytics engine',
    link: 'https://www.elastic.co/elasticsearch/',
  },
  {
    id: '55',
    name: 'GCP Pub/Sub',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description:
      'Messaging and event ingestion service for building event-driven systems and real-time analytics.',
    link: 'https://cloud.google.com/pubsub',
  },
  {
    id: '56',
    name: 'GitHub',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Git repository hosting and collaboration platform',
    link: 'https://github.com/',
  },
  {
    id: '57',
    name: 'GitHub Actions',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'CI/CD automation',
    link: 'https://github.com/features/actions',
  },
  {
    id: '58',
    name: 'GitHub Copilot',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: true,
    description: 'AI-powered code completion and suggestions for developers.',
    link: 'https://github.com/features/copilot',
  },
  {
    id: '59',
    name: 'Gitlab',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Git repository management and CI/CD platform',
    link: 'https://about.gitlab.com/',
  },
  {
    id: '60',
    name: 'Grafana',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Open-source platform for monitoring and observability',
    link: 'https://grafana.com/',
  },
  {
    id: '61',
    name: 'Jenkins',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Legacy CI/CD server',
    link: 'https://www.jenkins.io/',
  },
  {
    id: '62',
    name: 'Kong',
    ring: 'assess',
    quadrant: 'tools',
    isNew: true,
    description: 'API Gateway and Microservices Management Layer',
    link: 'https://konghq.com/',
  },
  {
    id: '63',
    name: 'Litmus Email Testing',
    ring: 'assess',
    quadrant: 'tools',
    isNew: false,
    description: 'Email rendering and spam testing',
    link: 'https://www.litmus.com/',
  },
  {
    id: '64',
    name: 'LogRocket',
    ring: 'hold',
    quadrant: 'tools',
    isNew: true,
    description: 'Frontend application monitoring and session replay tool',
    link: 'https://logrocket.com/',
  },
  {
    id: '65',
    name: 'Mermaid',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description:
      'A JavaScript-based diagramming and charting tool that uses a simple markdown-like syntax to create flowcharts, sequence diagrams, class diagrams, and more. It is often used in documentation and wikis to visualize concepts and processes easily.',
    link: 'https://mermaid.js.org/',
  },
  {
    id: '66',
    name: 'Mulesoft',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Enterprise integration platform',
    link: 'https://www.mulesoft.com/',
  },
  {
    id: '67',
    name: 'New Relic',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description:
      'Application performance monitoring and observability platform',
    link: 'https://newrelic.com/',
  },
  {
    id: '68',
    name: 'Nginx',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Web server and reverse proxy server',
    link: 'https://www.nginx.com/',
  },
  {
    id: '69',
    name: 'OpenTelemetry',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'Observability framework for cloud-native software',
    link: 'https://opentelemetry.io/',
  },
  {
    id: '70',
    name: 'Oxlint',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'Code linting for TypeScript/JavaScript',
    link: 'https://oxc-project.github.io/docs/guide/usage/linter.html',
  },
  {
    id: '71',
    name: 'PlantUML',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description:
      'An open-source tool that allows users to create diagrams from plain text descriptions. It supports various diagram types, including UML diagrams, flowcharts, and sequence diagrams, making it easier to visualize complex systems and processes.',
    link: 'https://plantuml.com/',
  },
  {
    id: '72',
    name: 'Playwright',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: true,
    description: 'E2E testing framework',
    link: 'https://playwright.dev/',
  },
  {
    id: '73',
    name: 'Port',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'Developer Experience Platform',
    link: 'https://www.getport.io/',
  },
  {
    id: '74',
    name: 'PostgreSQL',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Powerful, open source object-relational database system',
    link: 'https://www.postgresql.org/',
  },
  {
    id: '75',
    name: 'Prometheus',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Open-source systems monitoring and alerting toolkit',
    link: 'https://prometheus.io/',
  },
  {
    id: '76',
    name: 'Redis',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description:
      'In-memory data structure store, used as a database, cache, and message broker',
    link: 'https://redis.io/',
  },
  {
    id: '77',
    name: 'SaltStack',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Configuration management and automation',
    link: 'https://www.saltstack.com/',
  },
  {
    id: '78',
    name: 'Sentry',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Error tracking and performance monitoring platform',
    link: 'https://sentry.io/',
  },
  {
    id: '79',
    name: 'SonarQube',
    ring: 'trial',
    quadrant: 'tools',
    isNew: false,
    description: 'Static analysis for TypeScript/JavaScript',
    link: 'https://www.sonarsource.com/products/sonarqube/',
  },
  {
    id: '80',
    name: 'Spinnaker',
    ring: 'hold',
    quadrant: 'tools',
    isNew: false,
    description: 'Continuous delivery platform',
    link: 'https://spinnaker.io/',
  },
  {
    id: '81',
    name: 'Tanstack Query',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'Powerful data-fetching library for React',
    link: 'https://tanstack.com/query/latest/docs/react/overview',
  },
  {
    id: '82',
    name: 'Terraform',
    ring: 'trial',
    quadrant: 'tools',
    isNew: false,
    description: 'Infrastructure as Code',
    link: 'https://www.terraform.io/',
  },
  {
    id: '83',
    name: 'TestKube',
    ring: 'assess',
    quadrant: 'tools',
    isNew: true,
    description: 'Kubernetes-native test orchestration and management platform',
    link: 'https://testkube.io/',
  },
  {
    id: '84',
    name: 'Urql',
    ring: 'trial',
    quadrant: 'tools',
    isNew: true,
    description: 'GraphQL client for React',
    link: 'https://formidable.com/open-source/urql/',
  },
  {
    id: '85',
    name: 'Vite',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'Fast frontend build tool',
    link: 'https://vitejs.dev/',
  },
  {
    id: '86',
    name: 'Vitest',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: true,
    description: 'Unit testing framework',
    link: 'https://vitest.dev/',
  },
  {
    id: '87',
    name: 'Vuex',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'State management for Vue.js',
    link: 'https://vuex.vuejs.org/',
  },
  {
    id: '88',
    name: 'Zustand',
    ring: 'adopt',
    quadrant: 'tools',
    isNew: false,
    description: 'State management for React',
    link: 'https://zustand-demo.pmnd.rs/',
  },
]
